import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { UserCreateBody } from './create';
import { UserStatus } from '../auth';

export type UserUpdateResponse = { success: boolean };

export interface UserUpdateBody extends Partial<UserCreateBody> {
  status?: UserStatus;
}

export interface UserUpdatePayload {
  id: string;
  body: UserUpdateBody
}

export const userUpdate = (payload: UserUpdatePayload): Action<UserUpdatePayload> => ({
  type: actions.userUpdateTrigger.toString(),
  payload,
});

export const userUpdateClear = (): Action => ({
  type: actions.userUpdateClear.toString(),
});

export const userUpdateErrorClear = (): Action => ({
  type: actions.userUpdateErrorReset.toString(),
});

export function* userUpdateRequestSaga({ payload }: Action<UserUpdatePayload>) {
  yield put({
    type: actions.userUpdateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userUpdateError.toString(),
      payload: {
        message: 'UserUpdate: Parameters not passed.',
      },
    });

    return;
  }

  const { id, body } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users/${id}`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UserUpdateResponse, UserUpdateResponse>(
    response,
    actions.userUpdateSuccess.toString(),
    actions.userUpdateError.toString(),
    false,
    (userUpdateData) => userUpdateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userUpdateTrigger.toString(),
    defaultProcessingSaga(
      userUpdateRequestSaga,
      {
        error: actions.userUpdateError.toString(),
        locationCancel: actions.userUpdateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userUpdateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.userUpdateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userUpdateErrorReset.toString(),
    });
  });
}
